// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__10bkZ","productName":"Table_productName__7LGo4"};